{
    "productDashboard": {
        "common": {
            "last": "Ultimi",
            "for": "Per",
            "days": "giorni",
            "day": "giorno",
            "categories": "categorie",
            "open": "Aperto",
            "inProgress": "In corso",
            "inProgressShort": "In corso",
            "resolved": "Risolto",
            "clear": "Cancella",
            "selected": "selezionati",
            "clearAllFilters": "Cancella tutti i filtri"
        },
        "shell": {
            "dataUpdated": "Dati aggiornati",
            "latestTurn": "ultimo turno",
            "records": "record",
            "ofData": "di dati",
            "syncing": "Sincronizzazione…",
            "refresh": "↻ Aggiorna dati",
            "dataRefreshed": "Dati aggiornati.",
            "syncFailed": "Impossibile avviare la sincronizzazione.",
            "syncCompletedWithErrors": "Sincronizzazione completata con errori:",
            "timeRangeAria": "Intervallo di tempo",
            "overview": "Panoramica",
            "myhelpData": "dai dati di MyHelp",
            "rangeLabel": "Intervallo",
            "rangeAria": "Intervallo di date personalizzato",
            "rangeFrom": "Da",
            "rangeTo": "A",
            "rangeApplyAria": "Applica intervallo di date",
            "rangeClearAria": "Cancella intervallo di date",
            "rangeSelectBoth": "Seleziona sia la data di inizio che quella di fine.",
            "rangeInvalidOrder": "La data di inizio deve precedere quella di fine.",
            "rangeTooWide": "Seleziona un intervallo fino a",
            "dateRangeCaption": "Intervallo di date"
        },
        "overview": {
            "greetingMorning": "Buongiorno",
            "greetingAfternoon": "Buon pomeriggio",
            "greetingEvening": "Buonasera",
            "greetingNight": "Buonanotte",
            "subtitle": "Ecco cosa sta succedendo oggi nei tuoi prodotti.",
            "tabOverview": "Panoramica",
            "tabActionsForYou": "Azioni per te",
            "actionsTitle": "Azioni per te",
            "actionsMeta": "Prossimi passi consigliati per il team di prodotto",
            "kpiTotalQueries": "QUERY TOTALI",
            "kpiIncidentsRaised": "INCIDENTI SEGNALATI (Dal 10 settembre)",
            "kpiUpcoming": "FUNZIONALITÀ IN ARRIVO",
            "kpiCallback": "RICHIESTE DI RICHIAMATA (Dal 10 settembre)",
            "kpiLiveChat": "RICHIESTE DI CHAT DAL VIVO (Dal 10 settembre)",
            "viewBreakdown": "Dettaglio →",
            "viewAllIncidents": "Tutti gli incidenti →",
            "upcomingTitle": "Nuova funzionalità in arrivo",
            "upcomingSub": "Presto altri approfondimenti sui prodotti.",
            "topCategories": "Categorie di query principali",
            "viewAll": "Visualizza tutto →",
            "tipQueries": "Query",
            "uniqueUsersTitle": "Utenti unici",
            "detailedView": "Vista dettagliata",
            "usersPerDay": "Utenti unici al giorno",
            "usersPerWeek": "Utenti unici alla settimana",
            "usersPerMonth": "Utenti unici al mese",
            "uniqueUsersTrendTooltipLead": "Confronta",
            "uniqueUsersTrendTooltipConnector": "con",
            "kpiTooltips": {
                "totalQueries": "Numero totale di query ricevute in tutti i prodotti nell'intervallo di tempo selezionato.",
                "incidentsRaised": "Incidenti segnalati dalle conversazioni del chatbot, suddivisi per stato.",
                "upcoming": "Una nuova funzionalità della dashboard è in arrivo — torna presto a controllare.",
                "callback": "Richieste di richiamata inviate dagli utenti, suddivise per lingua.",
                "liveChat": "Richieste di chat dal vivo inviate dagli utenti, suddivise per lingua.",
                "feedbackCoverage": "Percentuale del totale delle query che hanno ricevuto un feedback dagli utenti (👍 o 👎)."
            }
        },
        "totalQueries": {
            "title": "Approfondimenti sulle query totali",
            "queries": "query",
            "vsPrior": "rispetto al periodo precedente",
            "chartTitle": "Query per categoria",
            "breakdownTitle": "Dettaglio per categoria",
            "thCategory": "CATEGORIA",
            "thQueries": "QUERY",
            "thShare": "QUOTA",
            "thDistribution": "DISTRIBUZIONE",
            "tipQueries": "Query",
            "tipShare": "Quota %",
            "searchPlaceholder": "Cerca",
            "matchesSuffix": "corrispondenze",
            "matchSuffix": "corrispondenza"
        },
        "incidents": {
            "title": "Categorie di problemi",
            "incidents": "incidenti",
            "thId": "ID",
            "thIssue": "QUERY / PROBLEMA",
            "thCategory": "CATEGORIA",
            "thProduct": "PRODOTTO",
            "thCompany": "AZIENDA",
            "thSeverity": "GRAVITÀ",
            "thStatus": "STATO",
            "empty": "Nessun incidente MyHelp in questo periodo.",
            "severityHigh": "Alta",
            "severityMedium": "Media",
            "severityLow": "Bassa",
            "incident": "incidente",
            "breakdownTitle": "Ripartizione per categoria",
            "thIncidents": "INCIDENTI",
            "thShare": "QUOTA",
            "thDistribution": "DISTRIBUZIONE",
            "searchPlaceholder": "Cerca",
            "matchesSuffix": "corrispondenze",
            "matchSuffix": "corrispondenza"
        },
        "incidentCategory": {
            "titlePrefix": "Incidenti in",
            "loadError": "Impossibile caricare gli incidenti.",
            "incident": "incidente",
            "incidents": "incidenti",
            "closeAria": "Chiudi",
            "thDate": "DATA",
            "empty": "Nessun incidente trovato per questa categoria.",
            "loading": "Caricamento…",
            "loadMorePrefix": "Carica altro (mostrati",
            "of": "di"
        },
        "userSentiment": {
            "title": "Approfondimenti sul feedback degli utenti",
            "summaryLikes": "mi piace",
            "summaryDislikes": "non mi piace",
            "last": "Ultimi",
            "days": "giorni",
            "likes": "Mi piace",
            "dislikes": "Non mi piace",
            "chartTitle": "Mi piace vs Non mi piace per categoria",
            "detailTitle": "Dettaglio feedback per categoria",
            "positive": "Positivo",
            "thingsWell": "Cosa ha funzionato bene",
            "thingsAttention": "Cosa richiede attenzione",
            "askAiHint": "Chiedi all'assistente AI in merito (si apre in una nuova scheda)",
            "searchPlaceholder": "Cerca",
            "matchesSuffix": "corrispondenze",
            "matchSuffix": "corrispondenza"
        },
        "products": {
            "title": "Categorie di prodotto",
            "products": "prodotti",
            "queryVolume": "Volume delle query",
            "incidents": "Incidenti",
            "sentiment": "Sentiment",
            "healthScore": "Punteggio di salute"
        },
        "companyFilter": {
            "allCompanies": "Tutte le aziende",
            "allCompaniesShort": "Tutte le aziende",
            "selectedSuffix": "aziende selezionate",
            "filterAria": "Filtra per azienda",
            "searchPlaceholder": "Cerca aziende…",
            "noMatchPrefix": "Nessuna azienda corrisponde"
        },
        "clusterFilter": {
            "allClusters": "Tutti i cluster",
            "allClustersShort": "Tutti i cluster",
            "selectedSuffix": "cluster selezionati",
            "filterAria": "Filtra per cluster",
            "searchPlaceholder": "Cerca cluster…",
            "noMatchPrefix": "Nessun cluster corrisponde"
        },
        "categoryFilter": {
            "allCategories": "Tutte le categorie",
            "selectedSuffix": "categorie selezionate",
            "filterAria": "Filtra per categoria",
            "searchPlaceholder": "Cerca categorie…",
            "allCategoriesShort": "Tutte le categorie",
            "selectedShort": "selezionate",
            "clear": "Cancella",
            "noMatchPrefix": "Nessuna categoria corrisponde a"
        },
        "categoryQueries": {
            "like": "Mi piace",
            "dislike": "Non mi piace",
            "titlePrefix": "Query in",
            "loadError": "Impossibile caricare le query.",
            "query": "query",
            "queries": "query",
            "preparing": "Preparazione…",
            "downloadExcel": "⬇ Scarica Excel",
            "closeAria": "Chiudi",
            "thQuery": "QUERY",
            "thSentiment": "SENTIMENT",
            "thDate": "DATA",
            "thSource": "FONTE",
            "thLanguage": "LINGUA",
            "thCompany": "AZIENDA",
            "colQuery": "Query",
            "colSentiment": "Sentiment",
            "colDate": "Data",
            "colSource": "Fonte",
            "colLanguage": "Lingua",
            "colCompany": "Azienda",
            "empty": "Nessuna query trovata per questa categoria.",
            "loading": "Caricamento…",
            "loadMorePrefix": "Carica altro (mostrando",
            "of": "di",
            "sortSentimentHint": "Clicca per ordinare per sentiment",
            "sortDateHint": "Clicca per ordinare per data"
        },
        "feedbackPie": {
            "likes": "Mi piace",
            "dislikes": "Non mi piace",
            "noFeedback": "Nessun feedback",
            "coverage": "COPERTURA FEEDBACK",
            "meta": "del totale delle query",
            "feedback": "feedback",
            "noData": "Nessun dato",
            "viewFeedback": "Feedback degli utenti →"
        },
        "requestCard": {
            "empty": "Nessuna richiesta in questo periodo.",
            "breakdown": "Ripartizione →"
        },
        "requestBreakdown": {
            "titleCallback": "Richieste di richiamata — Ripartizione per lingua",
            "titleLiveChat": "Richieste di live chat — Ripartizione per lingua",
            "breakdownTitle": "Ripartizione per lingua",
            "thLanguage": "LINGUA",
            "thCount": "CONTEGGIO",
            "thShare": "QUOTA",
            "thDistribution": "DISTRIBUZIONE",
            "language": "lingua",
            "languages": "lingue",
            "request": "richiesta",
            "requests": "richieste",
            "empty": "Nessuna richiesta in questo periodo."
        },
        "tabError": {
            "title": "Impossibile caricare i dati della dashboard",
            "message": "Il servizio dati non ha risposto. Riprova — non viene mostrato alcun dato quindi nulla qui è stimato."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Crea / aggiorna articoli della knowledge base",
                "hint": "Mantieni accurati e aggiornati i contenuti del tuo prodotto",
                "childTitle": "Creazione e aggiornamento della knowledge base",
                "childHint": "Come creare e aggiornare la knowledge base."
            },
            "scripts": {
                "title": "Crea e distribuisci script tramite Nexthink Remote Actions",
                "hint": "Automatizza la risoluzione del problema abilitando un'azione remota sul dispositivo dell'utente",
                "childTitle": "Link per ordinare Nexthink",
                "childHint": "Gestione delle azioni remote"
            }
        }
    }
}
